export default "__VITE_ASSET__Cm$GNKCK__"